module.exports = __webpack_public_path__ + "static/img/post_2.0f3da35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_2.png
// module id = wQEd
// module chunks = 0